import * as THREE from "three";
import React, { useRef, useEffect, useState } from "react";
import { useLoader, useThree, useFrame, useRender, extend } from "react-three-fiber";
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import useStore from "../store";
import ParticleBall from "./ParticleBall";
import PlayerOrbitControls from './PlayerOrbitControls.js';
import PlayerFollowBehindControls from './PlayerFollowBehindControls.js';
import gameStates from "../util/gameStates";

const Player = ({ globeRef }) => {
  const player = useRef();
  const playerWrapper = useRef(); // needed so we can have a fixed camera angle

  // const [playerWrapper, api] = useBox(() => ({ type: 'Kinematic', position: [0, globeRadius, 0], args: [1, 1, 1] }));
  const sphereMat = useRef();

  const debug = useStore((state) => state.debug);
  const { globeRadius, enableShadows } = useStore((state) => state.mutation);
  const gameState = useStore(state => state.gameState);
  const visualizerArray = useStore((state) => state.visualizerArray);

  useFrame(() => {
    if (!globeRef.current) {
      return;
    }
    let sum = 0;
    if (visualizerArray) {
      sum = visualizerArray.reduce((a, b) => a + b, 0);
    }
    const value = sum / 30 / 100;
    const newColor = value;
    sphereMat.current.color = new THREE.Color(newColor, newColor, newColor);
  });

  useEffect(() => {
    player.current.position.y = globeRadius;
    window.addEventListener("keydown", (e) => {
      // if (e.key === 'r') { }
    });
  }, []);

  return (
    <group ref={playerWrapper}>

      <group ref={player}>
        <group
          // change position to change pivot point
          position={[0, 1, 0]} // TODO: change once we get model
          onClick={(e) => console.log("click")}
          onPointerOver={(e) => console.log("hover")}
          onPointerOut={(e) => console.log("unhover")}
        >
          {(gameState === gameStates.PLAYING && !debug.orbitControls) ? (debug.fixedCameraControls ? <PlayerFollowBehindControls player={player} globe={globeRef} /> : <PlayerOrbitControls player={player} globe={globeRef} /> ) : null }

          <mesh position={[0, -0.75, 0]} castShadow={enableShadows}>
            <sphereGeometry
              attach="geometry"
              args={[0.15, 32, 32]}
            ></sphereGeometry>
            <meshBasicMaterial
              ref={sphereMat}
              attach="material"
              side={THREE.DoubleSide}
              color={"new THREE.Color(1, 1, 1)"}
            />
          </mesh>
          {/* { <ParticleBall radius={.15} count={50} />} */}
          {/* <boxBufferGeometry attach="geometry" args={[1, 1, 1]} />
                  <meshNormalMaterial attach="material" /> */}
        </group>
      </group>
    </group>
  );
};

export default Player;
